export default __webpack_public_path__ + "static/img/mustang-compressed.811bb60.jpg";